import React from "react";

import ShutterBProfileView from "./ShutterBProfileView";

const ViewShutterBProfile = () => {
  return (
    <div className="">
      <ShutterBProfileView hideReserveButton />
    </div>
  );
};

export default ViewShutterBProfile;
